import Footer from "../customer/components/footer";
import Header from "../customer/components/header";
import { useWebsite } from "../context/WebsiteContext";
import { shadeColor } from "../utils/colorUtils";

const CustomerLayout = ({ children }) => {
  const { websiteData } = useWebsite();

  const themePrimaryColor = websiteData && websiteData?.home_config && websiteData?.home_config?.primaryColor ? websiteData?.home_config?.primaryColor : "#ef233c";
  const themeSecondaryColor = websiteData && websiteData?.home_config && websiteData?.home_config?.secondaryColor ? websiteData?.home_config?.secondaryColor : "#0a2a52";
  const companyName = websiteData?.company_name || "Ezy Freight Logistics";
  const logo = websiteData && websiteData?.home_config && websiteData?.home_config?.logoURL ? websiteData?.home_config?.logoURL : "/images/logo.png";

  return (<div
    style={{
      "--primary-color": themePrimaryColor,
      "--primary-color-dark": shadeColor(themePrimaryColor, -15),
      "--secondary-color": themeSecondaryColor,
      "--secondary-color-dark": shadeColor(themeSecondaryColor, -15),
      // Flex column so the footer sits at the bottom even on short pages
      display: "flex",
      flexDirection: "column",
      minHeight: "100vh",
    }}
  >
    <Header companyName={companyName} logo={logo} />
    <main style={{ flex: "1 0 auto", display: "flex", flexDirection: "column" }}>
      {children}
    </main>
    <Footer
      companyName={companyName}
      logo={logo}
      phone={websiteData?.home_config?.phone || websiteData?.phone}
      email={websiteData?.home_config?.email || websiteData?.email}
      address={websiteData?.home_config?.address || websiteData?.company_address}
    />
  </div>);
}

export default CustomerLayout;